<div class="d-flex align-items-center title-layout">
  <div class="mr-2 center title-icon" style="height: 40px">
    <ng-container *ngIf="current">
      <em *ngIf="current.icon" [class]="current.icon"></em>
      <i
        *ngIf="current.img"
        class="fa menu-icon"
        [ngStyle]="{ '-webkit-mask-image': 'url(../../../assets/menu-icons/' + current.img + ')'}"
      ></i>
    </ng-container>
    <i *ngIf="svg" class="fa menu-icon" [ngStyle]="{ '-webkit-mask-image': 'url(' + svg + ')'}"></i>
  </div>
  <div class="line"></div>
  <div class="position-relative title-text" style="word-break: break-all">
    <div class="flex-column">
      <h3
        class="mb-0 d-flex align-items-start"
        style="color: var(--table-body-color, #4e5b65)"
      >
        {{title}}
        <!--   [autoClose]="'outside'" -->
        <span
          *ngIf="tooltip"
          placement="bottom"
          class="badge ml-1 badge-dark c-pointer help-badge"
          [ngbPopover]="popTooltip"
          popoverClass="principal-tooltip"
          >?</span
        >
      </h3>
      <small *ngIf="small">{{small}}.</small>
    </div>
  </div>
</div>

<ng-template #popTooltip>
  <div style="padding: 0.5rem 0.75rem">
    <p>{{tooltip}}</p>
  </div>
</ng-template>
